import { MovioTracker } from '@omnia/ui/src/lib/tracker/movioTracker'

export const movioTracker = new MovioTracker()
